import { Card, Row, Col, Tag, message,Button } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import "./invoice-card.scss";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { downloadVendorInvoice } from "../../../service/earning-invoice/earning-invoice";
import { useState } from "react";
import DecimalFormatter from "../../../common/decimal-converter/decimal-converter";
import { checkIsTurkeyKazak } from "../../../util/constantUtility";
import { useTranslation } from "react-i18next";
import { BrandColors, brandColor } from "../../../constants/brand";

const InvoiceCard = ({ item, onClick,userData }) => {
  const [downloading, setDownloading] = useState(false);
  const navigate = useNavigate();
  const isDraft = item?.type === "Draft";
  const isApproved = (item?.status === "Approved" || item?.status === "Paid");
  const { t } = useTranslation();

  // const getOrdinal = (day) => {
  //   if (day > 3 && day < 21) return "th";
  //   switch (day % 10) {
  //     case 1:
  //       return "st";
  //     case 2:
  //       return "nd";
  //     case 3:
  //       return "rd";
  //     default:
  //       return "th";
  //   }
  // };

  // const formatDate = (date) => {
  //   const d = dayjs(date);
  //   const day = d.date();

  //   return `${day}${getOrdinal(day)} ${d.format("MMM YYYY")}`;
  // };

  const formatDate = (date) => {
  return dayjs(date).format("DD MMM YYYY");
};

  const handleClick = () => {
    const id = item?.id;
    onClick && onClick(id);
  };

  const handleUploadInvoiceClick = (e) => {
    e.stopPropagation();
    navigate(
      `/earnings/add-new-invoice?flow=manual&isDraft=true&draftId=${item?.id}&moveType=${item?.moveType}`,
    );
  };

  const handleDownloadDraftInvoice = async (e) => {
    e.stopPropagation();

    try {
      setDownloading(true);

      const draftId = item?.id;

      const res = await downloadVendorInvoice(draftId);

      // assuming API returns file blob
      const blob = new Blob([res.data], { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `Draft_Invoice_${draftId}.pdf`;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      message.error("Failed to download invoice");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Card
      className="invoice-card"
      bordered={false}
      onClick={!isDraft ? handleClick : undefined}
    >
      {/* Header */}
      <Row
        justify="space-between"
        align="middle"
        className="invoice-card-header"
      >
        <div className="invoice-card-info">
          <span className="invoice-card-id">
            {!isDraft ? t("INV_UPLOAD_CARD_INVOICE_ID_LB"):""}{!isDraft ? ":":""} {item?.externalDraftId || item?.invoiceId || "-"}
          </span>

          <span className="invoice-card-date">
           <span style={{color:"var(--attention, #f99e00)",fontWeight:"bold"}}>{item?.moveType ==="Domestic" ? t("INV_UPL_SUMMARY_DOMESTIC_LB"):t("INV_UPL_SUMMARY_CROSS_BORDER_LB")}</span>&nbsp;{item?.moveType ? "|":""} &nbsp;<CalendarOutlined /> {t("INV_UPLOAD_CARD_ISSUED_ON_LB")} {formatDate(item?.createdAt)}
          </span>
        </div>

        {isDraft ? (
          <button className="invoice-button" onClick={handleUploadInvoiceClick}>
            <span>{t("INV_UPLOAD_CARD_UPLOAD_INVOICE_BTN")}</span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.566 7.50922C14.5721 7.50918 14.5784 7.50918 14.5846 7.50918C16.6557 7.50918 18.3346 9.19117 18.3346 11.2661C18.3346 13.1998 16.8763 14.7923 15.0013 15M14.566 7.50922C14.5783 7.37172 14.5846 7.23247 14.5846 7.09174C14.5846 4.55579 12.5326 2.5 10.0013 2.5C7.604 2.5 5.63658 4.34389 5.43499 6.69327M14.566 7.50922C14.4807 8.45633 14.1085 9.3205 13.537 10.0138M5.43499 6.69327C3.32129 6.89478 1.66797 8.67825 1.66797 10.8486C1.66797 12.8681 3.09944 14.5527 5.0013 14.9394M5.43499 6.69327C5.56652 6.68073 5.69983 6.67431 5.83464 6.67431C6.77282 6.67431 7.63859 6.98495 8.33505 7.50918"
                stroke={brandColor(BrandColors.primary, "#F99E00")}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.0013 10.834V17.5007M10.0013 10.834C9.4178 10.834 8.32758 12.4959 7.91797 12.9173M10.0013 10.834C10.5848 10.834 11.6751 12.4959 12.0846 12.9173"
                stroke={brandColor(BrandColors.primary, "#F99E00")}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        ) : (
          <Tag
            className={`invoice-card-status ${
              isApproved
                ? "invoice-card-status-approved"
                : item?.status === "Rejected"
                  ? "invoice-card-status-rejected"
                  : ""
            }`}
          >
            {item?.status ==="VerificationInProgress" ? "Verification In Progress" : item?.status ==="PartiallyPaid" ? "Partially Paid" :item?.status}
          </Tag>
        )}
      </Row>

      {/* Stats */}
      <Row gutter={16} className="invoice-card-stats">
        <Col span={8} className="invoice-card-stat">
          <span className="invoice-card-stat-label">{t("INV_UPLOAD_CARD_TOTAL_EARNINGS_LB")}</span>
          <span className="invoice-card-stat-value">
            {item?.currency}&nbsp;
            {(item?.totalEarning || item?.amount) ?  <DecimalFormatter amount={isDraft ? item?.totalEarning:item?.amount} country={checkIsTurkeyKazak(userData?.operatingCountry) ? "TRY" :item?.currency} flag={false} isShowDecimal={true}/>:"0"}
            </span>
        </Col>

        <Col span={8} className="invoice-card-stat">
          <span className="invoice-card-stat-label">{t("INV_UPLOAD_CARD_TOTAL_ORDERS_LB")}</span>
          <span className="invoice-card-stat-value">{item?.totalOrders}</span>
        </Col>

        <Col span={8} className="invoice-card-stat">
          <span className="invoice-card-stat-label">{t("INV_UPLOAD_CARD_TOTAL_TRIPS_LB")}</span>
          <span className="invoice-card-stat-value">{item?.totalTrips}</span>
        </Col>
      </Row>
      {/* DownLoad Button */}
      {isDraft && (
        <Button
          className="invoice-button"
          disabled={downloading}
          onClick={handleDownloadDraftInvoice}
          style={{ margin: "0 auto", marginTop: "12px" }}
          loading={downloading}
        >
          <span>
            {downloading ? t("INV_UPLOAD_CARD_TRUKKER_DRAFT_LOADER") : t("INV_UPLOAD_CARD_TRUKKER_DRAFT_INV_BTN")}
          </span>
          {!downloading && (
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99772 9.99943V3.33276M7.99772 9.99943C7.53092 9.99943 6.65874 8.6699 6.33105 8.33276M7.99772 9.99943C8.46452 9.99943 9.33672 8.6699 9.66439 8.33276"
                stroke={brandColor(BrandColors.primary, "#F99E00")}
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.33105 12.6672H12.6645"
                stroke={brandColor(BrandColors.primary, "#F99E00")}
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          )}
        </Button>
      )}
    </Card>
  );
};

export default InvoiceCard;
